<template>
  <div class="aboutUs-container">
    <div v-if="is" class="no-data">
      <img src="@/assets/image/pending-search.png" alt="">
      <p>很抱歉！暂无相关内容</p>
    </div>
    <div>
      <p class="title" v-html="title"></p>
      <div class="content-box" v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '',
      content: '',
      is: false
    }
  },
  methods: {
    init(data) {
      if (data) {
        this.title = data.title
        this.content = data.content
      } else {
        this.is = true
      }
    }
  }
}
</script>

<style lang='scss'>
.aboutUs-container {
  padding: 50px 63px;
  .title {
    // font-size: 36px;
    // font-weight: bold;
    // color: #145BC3;
    text-align: center;
  }
  .content-box {
    color: #333;
    margin-top: 22px;
    line-height: 1.6;
    font-size: 14px;
    p {
      img {
        max-width: 720px;
        text-align: center;
        display: block;
        margin: 40px auto;
      }
    }
  }
  .no-data {
    width: 304px;
    margin: 90px auto 0;
    text-align: center;
    img {
      margin-bottom: 30px;
    }
    p {
      color: #999;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
    .left {
      text-align: left;
      margin: 15px 40px;
    }
  }

}
</style>
